// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row.h-100 {\n  height: 100%;\n}\n.row.justify-content-end {\n  justify-content: flex-end;\n}\n", ""]);
// Exports
module.exports = exports;
